import { observable } from "mobx";

const mobiles = [
    {
        label: "Apple",
        value :"apple"
    },
    {
        label:"华为",
        value:"huawei"
    },
    {
        label:"小米",
        value:"mi"
    },
    {
        label:"三星",
        value:"sansumg"
    }
];

const mobileOS = [
    {
        label:"iOS",
        value:"ios"
    },
    {
        label:"Android",
        value:"android"
    }
];

// 身份证号
const IDs = [
    {
        title: "身份证",
        value: "sfz"
    },
    {
        title: "户口本",
        value: "hkb"
    },
    {
        title: "护照",
        value: "hz"
    },
    {
        title: "军官证",
        value: "jgz"
    },
    {
        title: "港澳通行证",
        value: "gatxz"
    },
];

const provinceCities = [
    {
        label:"江苏",
        value:"jiangsu",
        children: [
            {
                label:"南京",
                value:"nanjing",
                children: [
                    {
                        label:"浦口",
                        value:"pukou"
                    }
                ]
            },
            {
                label:"淮安",
                value:"huaian"
            }
        ]
    },
    {
        label: "浙江",
        value: "zhejiang",
        children: [
            {
                label: "杭州",
                value: "hangzhou"
            },
            {
                label: "宁波",
                value: "ningbo"
            }
        ]
    }
];

const optionsStore = observable( {
    mobiles,
    mobileOS,
    IDs,
    provinceCities
} );

export function getCityName(key, arr){
    let cityName, province = "";
    arr.forEach(city => {
        if (cityName) {
            return;
        }
        if (city.children) {
            province = city.label;
            cityName = getCityName(key, city.children);
            return;
        }
        if (key === city.value) {
            cityName = city.title || city.label;
            return;
        }
    });

    return cityName ? province + cityName : "";
}

export default optionsStore;

